<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Grupo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Nome do Grupo*"
                  counter="100"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="content.nomeDeExibicao"
                  label="Nome de Exibição*"
                  counter="100"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <v-select
                  v-model="content.permissoes"
                  :items="form.lists.listPermissoes"
                  :item-text="'nome'"
                  :item-value="'id'"
                  :rules="[(p) => p.some(v => $required(v)) || 'Informe uma ou mais permissões associadas!']"
                  label="Funcionalidades*"
                  multiple
                  outlined
                  dense
                  return-object
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center" v-if="content.permissoes.length">
              <v-col cols="12">
                <span class="small">Permissões Selecionadas</span>
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="permissao in content.permissoes" :key="permissao.id">
                    {{ permissao.nome }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Grupo } from '~/commons/classes/grupo';
import GrupoService from '~/services/grupo.service';
import PermissaoService from '~/services/permissao.service';

export default {
  props: new DialogProps(Grupo),
  mixins: [GrupoService, PermissaoService],
  data: () => ({
    form: {
      lists: {
        listPermissoes: [],
      },
    }
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const grupo = new Grupo(this.content).format();
          return this.edit
            ? this.$editarGrupo(grupo, grupo.id)
            : this.$cadastrarGrupo(grupo);
        });
      };
      if (this.$validarFormulario('Todos os campos obrigatórios devem ser preenchidos.')) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
  mounted() {
    this.$buscarPermissoes().then(({ data }) => {
      this.form.lists.listPermissoes = data.permissoes;
    });
  },
};
</script>
